import { P, S, T } from '../../styles/tokens';

interface SubProgress {
  current: number;
  total: number;
}

interface StepStripProps {
  current: number;
  total: number;
  sub?: SubProgress;
  /** When true, renders «ШАГ N ИЗ M» caption below the bar segments. Default: false. */
  showCaption?: boolean;
}

// inactive track colour — matches prototype '#E8E3D4'
const TRACK_INACTIVE = '#E8E3D4';

export function StepStrip({ current, total, sub, showCaption = false }: StepStripProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 0, width: '100%' }}>
    <div style={{ display: 'flex', gap: 4, width: '100%' }}>
      {Array.from({ length: total }, (_, i) => {
        const idx = i + 1;
        const done   = idx < current;
        const active = idx === current;

        const bg = done ? P.success : active ? P.terracotta : TRACK_INACTIVE;

        if (active && sub) {
          const fillPct = (sub.current / sub.total) * 100;
          return (
            <div
              key={i}
              data-testid={`step-${i}`}
              style={{
                flex: 1, height: 5, borderRadius: 3,
                background: TRACK_INACTIVE,
                position: 'relative', overflow: 'hidden',
              }}
            >
              <div
                data-testid={`step-${i}-fill`}
                style={{
                  position: 'absolute', left: 0, top: 0, bottom: 0,
                  width: `${fillPct}%`,
                  background: P.success,
                  transition: 'width 0.4s cubic-bezier(0.32, 0.72, 0, 1)',
                }}
              />
            </div>
          );
        }

        return (
          <div
            key={i}
            data-testid={`step-${i}`}
            style={{
              flex: 1, height: 5, borderRadius: 3,
              background: bg,
              transition: 'background 0.3s ease',
            }}
          />
        );
      })}
    </div>
    {showCaption && (
      <div style={{
        font: T.caption, color: S.tertiaryLabel,
        letterSpacing: 0.2, textTransform: 'uppercase' as const,
        marginTop: 8,
      }}>
        ШАГ {current} ИЗ {total}
      </div>
    )}
    </div>
  );
}
